import React, { useContext, useCallback } from "react";
import Navbar from "../navbar/navbar.js";
import { ThemeContext } from "../../context/ThemeContext";
import Footer from "../footer/footer.js";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

import WhiteCircle from "../../assets/img/svg/white-circle.svg";

import "./style.scss";

const Layout = ({ children }) => {
  const theme = useContext(ThemeContext);

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  function closeMenu() {
    theme.setMenuOpen(false);
  }

  return (
    <>
      <Navbar />
      <main
        className="layout"
        onClick={closeMenu}
      >
        <Particles
          id="tsparticles"
          init={particlesInit}
          style={{ position: "fixed", zIndex: -1 }}
          options={{
            fullScreen: { enable: true, zIndex: -1 },
            particles: {
              links: {
                enable: false,
              },
              move: {
                enable: true,
                speed: 1,
                direction: "none",
                random: false,
                straight: false,
                outModes: {
                  default: "out",
                },
                bounce: false,
              },
              number: {
                value: 5,
              },
              size: {
                value: theme.isMobile ? 50 : 150,
                random: true,
                anim: {
                  enable: false,
                  speed: 10,
                  size_min: 0.7,
                  sync: true,
                },
              },
              shape: {
                type: "image",
                image: [{ src: WhiteCircle, height: 200, width: 200 }],
              },
            },
          }}
        />
        {children}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
